/* oxlint-disable react/destructuring-assignment */
import { forwardRef, ReactNode } from "react";
import { BlankSearchInput } from "./BlankSearchInput";
import { FilledSearchInput } from "./FilledSearchInput";
import { BaseInputProps } from "./types";

export type SearchInputProps = BaseInputProps &
  (
    | { variant: "blank"; customSearchIcon?: ReactNode }
    | {
        variant: "filled";
        color: "primary" | "grey" | "white";
        size?: "sm" | "md";
      }
  );

export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
  (props, ref) => {
    if (props.variant === "blank") {
      const {
        onClear,
        alwaysShowClear,
        containerClassName,
        hasSettingsIndicator,
        popover,
        onSettingsClick,
        ...inputProps
      } = props;

      return (
        <BlankSearchInput
          containerClassName={containerClassName}
          alwaysShowClear={alwaysShowClear}
          hasSettingsIndicator={hasSettingsIndicator}
          popover={popover}
          onSettingsClick={onSettingsClick}
          onClear={onClear}
          {...inputProps}
          ref={ref}
        />
      );
    }

    if (props.variant === "filled") {
      const {
        color,
        size = "md",
        alwaysShowClear,
        containerClassName,
        hasSettingsIndicator,
        popover,
        onClear,
        onSettingsClick,
        ...inputProps
      } = props;

      return (
        <FilledSearchInput
          color={color}
          size={size}
          alwaysShowClear={alwaysShowClear}
          hasSettingsIndicator={hasSettingsIndicator}
          onSettingsClick={onSettingsClick}
          containerClassName={containerClassName}
          popover={popover}
          onClear={onClear}
          {...inputProps}
          ref={ref}
        />
      );
    }

    throw new Error("Search input variant has to be specified");
  }
);
